module.exports = __webpack_public_path__ + "img/round_bg.06b93b14.png";